import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HistoryPatchService {

  constructor() {
    this.patchHistoryAPI();
  }

  private patchHistoryAPI(): void {
    // Сохраняем оригинальные методы
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    // Перехватываем pushState
    history.pushState = (state: any, title: string, url?: string | URL | null) => {
      try {
        return originalPushState.call(history, state, title, url);
      } catch (error: any) {
        if (error?.name === 'SecurityError') {
          console.warn('[HistoryPatch] SecurityError blocked pushState call:', { state, title, url });
          // Можно добавить альтернативную логику здесь
          return;
        }
        throw error;
      }
    };

    // Перехватываем replaceState
    history.replaceState = (state: any, title: string, url?: string | URL | null) => {
      try {
        return originalReplaceState.call(history, state, title, url);
      } catch (error: any) {
        if (error?.name === 'SecurityError') {
          console.warn('[HistoryPatch] SecurityError blocked replaceState call:', { state, title, url });
          // Можно добавить альтернативную логику здесь
          return;
        }
        throw error;
      }
    };
  }

  /**
   * Безопасный вызов pushState с обработкой ошибок
   */
  safePushState(state: any, title: string, url?: string | URL | null): boolean {
    try {
      history.pushState(state, title, url);
      return true;
    } catch (error: any) {
      if (error?.name === 'SecurityError') {
        console.warn('[HistoryPatch] SecurityError in safePushState:', { state, title, url });
        return false;
      }
      throw error;
    }
  }

  /**
   * Безопасный вызов replaceState с обработкой ошибок
   */
  safeReplaceState(state: any, title: string, url?: string | URL | null): boolean {
    try {
      history.replaceState(state, title, url);
      return true;
    } catch (error: any) {
      if (error?.name === 'SecurityError') {
        console.warn('[HistoryPatch] SecurityError in safeReplaceState:', { state, title, url });
        return false;
      }
      throw error;
    }
  }
} 